import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
	merchants: null, // array of merchants
	activeMerchant: null // active merchant
}

// mutations
export const mutations = {
	[types.FETCH_MERCHANTS_SUCCESS] (state, { merchants }) {
		state.merchants = merchants
	},

	[types.FETCH_MERCHANTS_FAILURE] (state) {
		state.merchants = null
	},

	[types.FETCH_MERCHANT_SUCCESS] (state, { merchant }) {
		state.activeMerchant = merchant
	},

	[types.FETCH_MERCHANT_FAILURE] (state) {
		state.activeMerchant = null
	},

	[types.RESET_MERCHANT] (state) {
		state.activeMerchant = null
	},

	[types.RESET_MERCHANTS] (state) {
		state.merchants = null
	}
}

// actions
export const actions = {

	async fetchMerchants ({ commit }) {
		try {
			const res = await axios.get('/merchants/me')

      if (res.status === 200) {
        commit(types.FETCH_MERCHANTS_SUCCESS, { merchants: res.data })
      } else {
        commit(types.FETCH_MERCHANTS_FAILURE)
      }
		} catch (e) {
			commit(types.FETCH_MERCHANTS_FAILURE)
		}
	},

	resetMerchants ({ commit }) {
		commit(types.RESET_MERCHANTS)
	},

	async fetchMerchant ({ commit }, merchantid = null) {
		if (merchantid) {
			try {
				const { data } = await axios.get('/merchants/me/' + merchantid)

				commit(types.FETCH_MERCHANT_SUCCESS, { merchant: data })
			} catch (e) {
				commit(types.FETCH_MERCHANT_FAILURE)
			}
		} else {
			commit(types.FETCH_MERCHANT_FAILURE)
		}
	},

	resetMerchant ({ commit }) {
		commit(types.RESET_MERCHANT)
	}

}

// getters
export const getters = {
	Merchants: state => state.merchants,
	activeMerchant: state => state.activeMerchant
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant.js